export default "__VITE_ASSET__D5N2T3Ai__"